import type { RouteLocationNormalizedLoaded } from 'vue-router'
import starApi from '@/api/starApi'

/** 星投页面权益 source，与后端 PAGE 枚举一致 */
export enum StarPageSource {
  HOME = 3,
  STOCK_AI = 4,
  STOCK_CUSTOM = 5,
  GROUP_RESULT = 6,
  GROUP_DETAIL = 7,
}

export type StarPageGroup = 'home' | 'stock' | 'group_result'

const CACHE_PREFIX = 'star_page_free_'

function getUserName(route: RouteLocationNormalizedLoaded): string {
  return (
    (route.query.username as string) ||
    (route.query.userName as string) ||
    ''
  )
}

function resolveSource(pageGroup: StarPageGroup, route: RouteLocationNormalizedLoaded): StarPageSource {
  switch (pageGroup) {
    case 'home':
      return StarPageSource.HOME
    case 'stock':
      // stock/index 无 quantType 时默认自定义；stock/result 按 quantType 区分智能/自定义
      return Number(route.query.quantType) === 2 ? StarPageSource.STOCK_AI : StarPageSource.STOCK_CUSTOM
    case 'group_result':
      return route.query.isDetails || route.query.isfrom === '2'
        ? StarPageSource.GROUP_DETAIL
        : StarPageSource.GROUP_RESULT
  }
}

function getCacheKey(userName: string, pageGroup: StarPageGroup): string {
  return `${CACHE_PREFIX}${userName}_${pageGroup}`
}

/**
 * 进入星投首页时发放免费权益，同一用户仅调用一次（localStorage 持久缓存）。
 */
export async function checkStarPageFree(
  pageGroup: StarPageGroup,
  route: RouteLocationNormalizedLoaded
): Promise<void> {
  const token = route.query.token as string
  const userName = getUserName(route)
  if (!token || !userName) return

  const cacheKey = getCacheKey(userName, pageGroup)
  if (localStorage.getItem(cacheKey)) return

  const source = resolveSource(pageGroup, route)
  try {
    await starApi.sendStarFree({
      data: { source },
      headers: { token, userName }
    })
    localStorage.setItem(cacheKey, '1')
  } catch (e) {
    console.error('[checkStarPageFree] 发放星投页面免费权益失败', e)
  }
}
